// Réglages cachés : valeurs par défaut, bornes et nettoyage. Les réglages sont enregistrés dans le stockage local
// et relus par cleanSettings(), qui accepte n'importe quelle valeur (ancienne sauvegarde, corrompue, hors bornes)
// et rend des réglages valides. Pur.
import { DEFAULT_DEV_SETTINGS } from '../config/constants.js';

// [min, max, pas] de chaque réglage numérique (les mêmes que les curseurs du menu, voir index.html)
export const SETTING_RANGES = Object.freeze({
  worldGrowth: [0, 800, 40], captureRadius: [16, 80, 2], panSpeed: [40, 400, 10], panMaxSpeed: [120, 1200, 20],
  panAccelTime: [0, 4, 0.1], wheelSensitivity: [0.3, 3, 0.1], dragFriction: [1, 12, 1],
  gyroHorizonOffset: [-40, 40, 1], gyroYawSpeed: [0.3, 3, 0.1], gyroPitchSpeed: [0.3, 3, 0.1], gyroSmoothing: [0, 90, 5],
  photoCostPercent: [1, 25, 1], batterySeconds: [30, 1800, 10], chargeMinutes: [0, 180, 1],
  familySize: [0, 15, 1], ghostSpeed: [0, 120, 2], summonDelay: [0, 60, 1], summonSpeed: [20, 1500, 10], hintDelay: [1, 15, 1], musicBpm: [60, 240, 1], startLevel: [1, 6, 1],
});

/** Réglages par défaut : ceux du jeu (constants.js), les options d'affichage et l'édition (iosVersion : la version iOS, simulée, voir game.js). */
export const DEFAULT_SETTINGS = Object.freeze({ ...DEFAULT_DEV_SETTINGS, reducedMotion: false, iosVersion: false });

const snap = (value, [min, max, step]) => {
  const stepped = min + Math.round((value - min) / step) * step;
  return Math.round(Math.min(max, Math.max(min, stepped)) * 1000) / 1000;
};

/** Revalide des réglages venus du stockage : valeurs hors bornes ramenées dans les bornes, inconnues ignorées. */
export function cleanSettings(raw) {
  const source = raw && typeof raw === 'object' ? raw : {};
  const clean = { ...DEFAULT_SETTINGS };
  for (const [key, range] of Object.entries(SETTING_RANGES)) {
    const value = Number(source[key]);
    if (source[key] !== null && source[key] !== '' && Number.isFinite(value)) clean[key] = snap(value, range);
  }
  clean.reducedMotion = source.reducedMotion === true;
  clean.iosVersion = source.iosVersion === true;
  return clean;
}
